var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"name":_vm.field.name,"label":_vm.field.label,"help":_vm.field.help,"id":_vm.id,"validation-name":_vm.field.label,"type":"suggestion","validation":"required"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true},{key:"help",fn:function(){return [_vm._t("help")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }